import { apiClient } from '@lib/core/api';

export interface AppReviewSubmitRequest {
  rating: number;
}

export interface AppReviewResponse {
  success: boolean;
  message?: string;
}

class AppReviewApiClient {
  /**
   * Submit app review rating
   * PUT /v1/users/app-review/{userId}?docId={notificationId}
   */
  async submitReview(userId: string, notificationId: string, rating: number): Promise<AppReviewResponse> {
    try {
      const request: AppReviewSubmitRequest = {
        rating,
      };

      const response = await apiClient.put(`/users/app-review/${userId}?docId=${notificationId}`, request);

      if (response.status === 200 || response.status === 204) {
        return {
          success: true,
          message: (response.data as any)?.message || 'Review submitted successfully',
        };
      }

      throw new Error((response.data as any)?.message || 'Failed to submit review');
    } catch (error) {
      console.error('App review submission failed:', error);
      return {
        success: false,
        message: error instanceof Error ? error.message : 'Failed to submit review',
      };
    }
  }

  /**
   * Cancel/dismiss app review notification
   * DELETE /v1/users/app-review/{userId}?docId={notificationId}
   */
  async cancelReview(userId: string, notificationId: string): Promise<AppReviewResponse> {
    try {
      const response = await apiClient.delete(`/users/app-review/${userId}?docId=${notificationId}`);

      if (response.status === 200 || response.status === 204) {
        return {
          success: true,
          message: (response.data as any)?.message || 'Review cancelled successfully',
        };
      }

      throw new Error((response.data as any)?.message || 'Failed to cancel review');
    } catch (error) {
      console.error('App review cancellation failed:', error);
      return {
        success: false,
        message: error instanceof Error ? error.message : 'Failed to cancel review',
      };
    }
  }
}

export const appReviewApi = new AppReviewApiClient();